var _style, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _defs, _clipPath, _g, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _defs2, _clipPath2, _g2, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _defs3, _clipPath3, _g3, _path80, _defs4, _clipPath4, _g4, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _defs5, _clipPath5, _g5, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBusinessintegrity(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Layer_1",
    x: 0,
    y: 0,
    viewBox: "0 0 1066.35 558.41",
    xmlSpace: "preserve",
    width: 1280,
    height: 670.01876172608,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null)), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#ccebfc",
    d: "M17.78 15h861.74v341.06H17.78z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M413.29 81.76c-4.12-9.15-6.18-20.85-6.18-30.35h-29.64c0 9.5 2.06 21.2 6.18 30.35h29.64z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#8cd3f8",
    d: "M473.45 97.47c-4.12-9.15-6.17-20.85-6.17-30.35h-29.65c0 9.5 2.06 21.2 6.18 30.35h29.64z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#add095",
    d: "M304.47 226.49c-4.12-9.15-6.18-20.85-6.18-30.35h-29.64c0 9.5 2.06 21.2 6.18 30.35h29.64z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M261.88 78.66c-4.12-9.15-6.18-20.85-6.18-30.35h-29.64c0 9.5 2.06 21.2 6.18 30.35h29.64z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#8cd3f8",
    d: "M266.53 144.33c-4.12-9.15-6.18-20.85-6.18-30.35h-29.64c0 9.5 2.06 21.2 6.18 30.35h29.64z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M308.93 129.16c-4.12-9.15-6.17-20.85-6.17-30.35h-29.65c0 9.5 2.06 21.2 6.18 30.35h29.64z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#8cd3f8",
    d: "M308.93 86.82c-4.12-9.15-6.17-20.85-6.17-30.35h-29.65c0 9.5 2.06 21.2 6.18 30.35h29.64z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M177.82 98.55c4.12-9.15 6.17-20.85 6.17-30.35h29.65c0 9.5-2.06 21.2-6.18 30.35h-29.64z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#add095",
    d: "M729.47 139.97c4.12-9.15 6.17-20.85 6.17-30.35h29.65c0 9.5-2.06 21.2-6.18 30.35h-29.64zM675.88 86.82c4.12-9.15 6.18-20.85 6.18-30.35h29.64c0 9.5-2.06 21.2-6.18 30.35h-29.64z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M437.62 115.48h93.26v61.69h-93.26z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#8cd3f8",
    d: "M445.15 105.06h6.3v17.13h-6.3z",
    transform: "rotate(-23.404 448.308 113.63)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "#8cd3f8",
    d: "M521.83 113.76h17.13v6.3h-17.13z",
    transform: "rotate(-84.272 530.395 116.914)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M327 142.88h61.69v93.26H327z",
    transform: "rotate(-5.878 357.859 189.517)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "#8cd3f8",
    d: "M344.61 140.78h17.13v6.3h-17.13z",
    transform: "rotate(-86.549 353.175 143.924)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "#8cd3f8",
    d: "M357.41 225.56h6.3v17.13h-6.3z",
    transform: "rotate(-12.727 360.568 234.135)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M562.98 195.35l-23.49 105.27h32.64z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#009df0",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3.346,
    d: "M562.98 195.35l-23.49 105.27h32.64z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fill: "#b2e2fa",
    d: "M626.92 441.88l1.89 104.62h-53.53l4.84-10.3 7.33-7.89 6.6-6.51.22-9.6-13.37-88.56zM715.63 546.5h-46.26l-3.52-26.78-22.16-77.84h43.71l13.36 75.9 3.15 10.43z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#009df0",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3.346,
    d: "M584.66 446.93c3.74 29.44 7.37 52.17 9.61 65.26 1.07 6.24-1.6 12.54-6.83 16.11a27.853 27.853 0 0 0-10.5 13.58l-1.66 4.61M669.37 546.5l-3.51-26.78-18.58-70.67M690.43 449.05l10.34 68.73c.85 5.68 2.97 11.1 6.18 15.86l8.68 12.85h337.04M628.81 546.5l-2.6-96.76"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#009df0",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2.4,
    d: "M589.54 526.75l9.94 2.92M628.08 519.08c-16.18 5.84-27.96 1.27-27.96 1.27M666.09 521.54l20.29.51"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_1_",
    d: "M562.95 153.88h132.68v295.15H562.95z"
  }))), _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000002348370817737689230000010293912113660169389_"
  }, /*#__PURE__*/React.createElement("use", {
    overflow: "visible",
    xlinkHref: "#SVGID_1_"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#SVGID_00000002348370817737689230000010293912113660169389_)"
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000173865471540639060810000010557229902073541030_",
    d: "M562.95 153.88h132.68v295.15H562.95z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000128474715062098649990000016803971976962705854_"
  }, /*#__PURE__*/React.createElement("use", {
    overflow: "visible",
    xlinkHref: "#SVGID_00000173865471540639060810000010557229902073541030_"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M656.01 245.38c5.44 16.24 5.53 16.51 5.67 16.73 2.94 5.93 4.95 12.27 6.02 18.78 5.93 36.85 26.59 164.84 27.93 168.14H569.24l-6.2-137.18c-.04-.94-.09-1.92-.09-2.86 0-5 .71-9.99 2.01-14.77a55.935 55.935 0 0 0 1.96-17.04l-1.61-31.81 90.7.01z",
    clipPath: "url(#SVGID_00000128474715062098649990000016803971976962705854_)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000180342053240583871890000011525582451552807870_",
    d: "M562.95 153.88h132.68v295.15H562.95z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000150081649832820829830000003552054299712877211_"
  }, /*#__PURE__*/React.createElement("use", {
    overflow: "visible",
    xlinkHref: "#SVGID_00000180342053240583871890000011525582451552807870_"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#b2e2fa",
    d: "M654.8 232.89c0 4.19.4 8.39 1.2 12.49h-90.7l-2.05-40.28c-.85-17.22 8.83-33.19 24.49-40.37l23.6-10.84 29 10.08c13.43 4.68 21.59 18.29 19.36 32.39l-4.1 26.23c-.53 3.43-.8 6.87-.8 10.3",
    clipPath: "url(#SVGID_00000150081649832820829830000003552054299712877211_)"
  })))), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#009df0",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3.346,
    d: "M611.35 153.88l-23.61 10.84a42.082 42.082 0 0 0-24.47 40.35l3.63 72.1c.24 5.75-.41 11.51-1.94 17.06a55.417 55.417 0 0 0-1.91 17.62l6.2 137.2h126.36c-1.33-3.34-22-131.3-27.94-168.16a65.777 65.777 0 0 0-6.02-18.8 65.784 65.784 0 0 1-6.06-39.52l4.14-26.25c2.22-14.06-5.95-27.7-19.39-32.37l-28.99-10.07zM656.02 245.4h-90.71"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M634.1 161.79v137.59H675l-13.85-67.19.84-20.99 35.43 12.97 37.43-4.59c8-.99 13.6-8.4 12.35-16.37l-3.02-19.3-48.56 2.98-61.52-25.1z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#009df0",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3.346,
    d: "M634.1 161.79v137.59H675l-13.85-67.19.84-20.99 35.43 12.97 37.43-4.59c8-.99 13.6-8.4 12.35-16.37l-3.02-19.3-48.56 2.98-61.52-25.1z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fill: "#e2b290",
    d: "M782.25 185.57l3.86-4.22a4.218 4.218 0 0 0 .35-5.25 4.213 4.213 0 0 0-4.84-1.57l-23.23 8.13-22.61 1.74 1.41 18.34c.19 2.5 2.55 4.25 5 3.71l19.15-4.25 28.77 3.59 15.95-7.28a5.825 5.825 0 0 0 2.97-3.09c1.5-3.64-.96-7.7-4.89-8.04l-25.41-2.19"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#009df0",
    strokeMiterlimit: 10,
    strokeWidth: 3.346,
    d: "M782.25 185.57l3.86-4.22a4.218 4.218 0 0 0 .35-5.25 4.213 4.213 0 0 0-4.84-1.57l-23.23 8.13-22.61 1.74 1.41 18.34c.19 2.5 2.55 4.25 5 3.71l19.15-4.25 28.77 3.59 15.95-7.28a5.825 5.825 0 0 0 2.97-3.09c1.5-3.64-.96-7.7-4.89-8.04l-25.41-2.19"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M598.53 159.13v140.26h-43.41l7.85-65.12v-38.91a29.78 29.78 0 0 1 16.42-26.62l19.14-9.61z"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#009df0",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3.346,
    d: "M598.53 159.13v140.26h-43.41l7.85-65.12v-38.91a29.78 29.78 0 0 1 16.42-26.62l19.14-9.61"
  })), _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000062906697741930826400000010250488387199445161_",
    d: "M584.53 89.78h59.4v92.65h-59.4z"
  }))), _clipPath2 || (_clipPath2 = /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000140729005372605419380000016208157537551672487_"
  }, /*#__PURE__*/React.createElement("use", {
    overflow: "visible",
    xlinkHref: "#SVGID_00000062906697741930826400000010250488387199445161_"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#SVGID_00000140729005372605419380000016208157537551672487_)"
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000044175325749817032440000013499790723856199593_",
    d: "M584.53 89.78h59.4v92.65h-59.4z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000147186031007245628850000005053921281380330144_"
  }, /*#__PURE__*/React.createElement("use", {
    overflow: "visible",
    xlinkHref: "#SVGID_00000044175325749817032440000013499790723856199593_"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M627.24 147.39l10.84 1.41c-1.54 4.54-2.31 9.3-2.31 14.05 0 2.36.17 4.76.56 7.12l.34 2.14-10.67 7.45a15.766 15.766 0 0 1-19.11-.77l6.81-10.54c2.48-2.65 4.67-5.35 6.51-8.01 3.04-4.41 5.31-8.73 7.03-12.85",
    clipPath: "url(#SVGID_00000147186031007245628850000005053921281380330144_)"
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000049931098112884212630000001697485055789787009_",
    d: "M584.53 89.78h59.4v92.65h-59.4z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000031928837558144313580000011750886122732955065_"
  }, /*#__PURE__*/React.createElement("use", {
    overflow: "visible",
    xlinkHref: "#SVGID_00000049931098112884212630000001697485055789787009_"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#e2b290",
    d: "M632.12 123.75s.51 10.5-4.89 23.65a69.88 69.88 0 0 1-7.02 12.85l-.09-.08h-8.14c-6.86 0-13.07-3.64-16.45-9.42-.51-.9-.98-1.89-1.37-2.87l-1.41-3.73c-.25-.73-.51-1.41-.77-2.14-2.44-7.11-3.73-14.61-3.73-22.15 6.64-3.04 12.89-4.11 18.46-4.11 15.09-.02 25.41 8 25.41 8",
    clipPath: "url(#SVGID_00000031928837558144313580000011750886122732955065_)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000080922439667337051930000008053450201177558443_",
    d: "M584.53 89.78h59.4v92.65h-59.4z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000022553681697110826980000011874492903832457658_"
  }, /*#__PURE__*/React.createElement("use", {
    overflow: "visible",
    xlinkHref: "#SVGID_00000080922439667337051930000008053450201177558443_"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M620.21 160.24c-1.84 2.65-4.03 5.35-6.51 8.01l-6.81 10.54-13.84-9.55 2.48-18.51c3.39 5.79 9.6 9.43 16.45 9.43h8.14l.09.08z",
    clipPath: "url(#SVGID_00000022553681697110826980000011874492903832457658_)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000174571727251555750070000007718794076943337379_",
    d: "M584.53 89.78h59.4v92.65h-59.4z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000160170644337430747670000011473489922860723880_"
  }, /*#__PURE__*/React.createElement("use", {
    overflow: "visible",
    xlinkHref: "#SVGID_00000174571727251555750070000007718794076943337379_"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M632.12 123.75s-10.32-8.01-25.4-8.01c-5.57 0-11.83 1.07-18.46 4.11 0 7.54 1.28 15.04 3.73 22.15h-.04l-.99-.95c-5.53-5.52-6.47-12.29-6.42-20.13.17-16.84 11.69-31.14 28.48-31.14h.17c8.27 0 15.81 3.34 21.29 8.7 5.53 5.35 9 12.76 9.25 21.03l.17 4.97c.21 6.86-1.2 13.66-4.07 19.88a35.7 35.7 0 0 0-1.75 4.45l-10.84-1.41c5.39-13.16 4.88-23.65 4.88-23.65",
    clipPath: "url(#SVGID_00000160170644337430747670000011473489922860723880_)"
  })))), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#009df0",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3.346,
    d: "M599.09 116.43c19.13-3.49 33.02 7.32 33.02 7.32s1.16 23.77-18.41 44.49"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#009df0",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3.346,
    d: "M620.13 160.14h-8.16c-7.91 0-14.99-4.88-17.81-12.27l-1.43-3.74a67.98 67.98 0 0 1-4.47-24.26"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#009df0",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3.346,
    d: "M625.97 179.58c-5.81 4.06-13.62 3.74-19.06-.8l-8.18-6.36a10.268 10.268 0 0 1-3.95-8.71l.77-12.96M584.55 117.79c.15-16.88 11.76-28.09 28.63-28.03 16.55.05 30.07 13.22 30.57 29.75l.15 4.98c.21 6.85-1.19 13.66-4.07 19.87a44.078 44.078 0 0 0-3.52 25.59l.35 2.15"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#009df0",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2.4,
    d: "M601.29 126.24l-4.56.72M617.51 127.82l4.74 1.53M613.96 149.56l-1.88.19c-2.26.23-4.54.08-6.75-.45l-.04-.01M610.84 142.33l-.56.18c-.74.24-1.54.18-2.23-.17l-.56-.29a2.13 2.13 0 0 1-.81-2.69l.36-.81M618.4 132.18v.73M600.16 130.75v.73"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#009df0",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3.346,
    d: "M410.03 545.6L432 418.37"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M404.99 291.41a29.184 29.184 0 0 1 17.47-21.87l23.17-9.65c4.9-2 7.65-7.2 6.59-12.38l-2.73-13.23-2.24-.9a6.202 6.202 0 0 1-3.9-5.76v-.33c.09-1.88 1.01-3.46 2.36-4.52l-1.32-1.94c-1.64-2.4-2.7-5.13-3.11-8.01l-.3-2.11c-.14-.94-.21-1.86-.21-2.77 0-7.82 4.8-14.95 12.26-17.8 12.2-4.68 25.71-4.78 37.96-.24l2.59.96c3.86 1.41 6.52 4.95 6.87 9.02l.07.82c.02.29.02.57.02.85 0 3.3-1.5 6.43-4.17 8.43 0 0 1.34 15.94-3.06 28.72-2.57 7.51-6.47 11.54-10.64 13.59l1.81.59 23.52 7.67a41.494 41.494 0 0 1 27.31 29.03l11.77 45.33c1.36 5.2 1.03 10.71-.89 15.73l-4.99 13.02c-1.44 3.72-1.98 7.7-1.6 11.63l1.27 13.73H435.48l-1.14-30.94-17.89 3.43c-11.4 2.19-21.51-7.62-19.67-19.08l8.21-51.02z"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    fill: "#33b1f3",
    d: "M477.04 284.37l4.16 16.05-18.03 6.92.58-22.97 1.18-1.49c2.24-2.82 6.36-3.26 9.14-.97l2.97 2.46z"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#009df0",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3.346,
    d: "M436.59 389.01h105.38l-1.27-13.73c-.37-3.95.18-7.93 1.61-11.63l5.01-13.03a25.8 25.8 0 0 0 .89-15.73l-11.77-45.33a41.493 41.493 0 0 0-27.32-29.02l-36.03-11.74"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    fill: "#33b1f3",
    d: "M462.52 545.6l2.86-15.15c1.21-6.41.77-13.03-1.28-19.22l-34.53-104.26 29.32-26.41 15.51 11.07 18.83 100.81c.61 3.27.29 6.66-.93 9.76l-.51 1.29a17.74 17.74 0 0 0 1.65 16.2 17.74 17.74 0 0 1 2.56 6.29l3.84 19.62"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#009df0",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3.346,
    d: "M462.52 545.6l2.86-15.15c1.21-6.41.77-13.03-1.28-19.22l-34.53-104.26 29.32-26.41 15.51 11.07 18.83 100.81c.61 3.27.29 6.66-.93 9.76l-.51 1.29a17.74 17.74 0 0 0 1.65 16.2 17.74 17.74 0 0 1 2.56 6.29l3.84 19.62M435.77 317.29l-14.76 3.84"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    fill: "#ccebfc",
    d: "M477.43 291.71l56.93 14.76-36.01 77.57-56.92-14.76z"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    fill: "#b2e2fa",
    d: "M517.72 417.67h-20.88c-10.63 0-20.98-3.36-29.59-9.6L456.12 400l-30.46 64.2a7.208 7.208 0 0 1-8.15 3.93 7.197 7.197 0 0 0-8.61 5.2l-1.52 5.81-6.68 26.08-26.05-6.93c-6.31-1.68-9.94-8.28-7.98-14.51.79-2.5 2.41-4.66 4.6-6.11l5.96-3.94c5.55-3.68 9.81-9.02 12.15-15.25l31.72-84.44c1.82-4.84 4.58-9.18 8.03-12.81 1.56-1.64 4.18-2.35 6.01-3.68 2.23-1.63 6.28-4.93 6.28-4.93a37.74 37.74 0 0 1 9.69-2.77c7.89-1.16 15.94.2 23.02 3.88l67.82 35.29.17 2.79c.82 14.02-10.34 25.86-24.4 25.86"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#009df0",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3.346,
    d: "M517.72 417.67h-20.88c-10.63 0-20.98-3.36-29.59-9.6L456.12 400l-30.46 64.2a7.208 7.208 0 0 1-8.15 3.93 7.197 7.197 0 0 0-8.61 5.2l-1.52 5.81-6.68 26.08-26.05-6.93c-6.31-1.68-9.94-8.28-7.98-14.51.79-2.5 2.41-4.66 4.6-6.11l5.96-3.94c5.55-3.68 9.81-9.02 12.15-15.25l31.72-84.44c1.82-4.84 4.58-9.18 8.03-12.81 1.56-1.64 4.18-2.35 6.01-3.68 2.23-1.63 6.28-4.93 6.28-4.93a37.74 37.74 0 0 1 9.69-2.77c7.89-1.16 15.94.2 23.02 3.88l67.82 35.29.17 2.79c.82 14.02-10.34 25.86-24.4 25.86z"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffe3cc",
    d: "M455.38 312.07l14.33-6.25-.45 1.84c-.77 3.18 2.02 6.08 5.22 5.44l11.97-2.4a5.557 5.557 0 0 1 6.63 4.91c.2 2.03-.73 4.02-2.43 5.15l-5.74 3.87-4.22 7.23c-2.16 3.7-6.27 5.81-10.53 5.41l-14.79-1.38v-23.82h.01z"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#009df0",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3.346,
    d: "M455.38 312.07l14.33-6.25-.45 1.84c-.77 3.18 2.02 6.08 5.22 5.44l11.97-2.4a5.557 5.557 0 0 1 6.63 4.91c.2 2.03-.73 4.02-2.43 5.15l-5.74 3.87-4.22 7.23c-2.16 3.7-6.27 5.81-10.53 5.41l-14.79-1.38v-23.82h.01z"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffe3cc",
    d: "M522.58 353.16v26.02l-14.84-3.44a17.865 17.865 0 0 1-12.51-10.68l-3.03-7.45c-.6-1.47-.79-3.07-.57-4.64.82-5.71 6.74-9.18 12.12-7.09l18.83 7.28z"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#009df0",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3.346,
    d: "M522.58 353.16v26.02l-14.84-3.44a17.865 17.865 0 0 1-12.51-10.68l-3.03-7.45c-.6-1.47-.79-3.07-.57-4.64.82-5.71 6.74-9.18 12.12-7.09l18.83 7.28z"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffe3cc",
    d: "M454.13 190.11a53.798 53.798 0 0 1 37.95-.22l2.6.96c3.85 1.42 6.52 4.94 6.86 9.03l.07.82c.3 3.6-1.26 7.1-4.14 9.28l-4.94 34.98a8.545 8.545 0 0 1-6.92 7.38l-.54 12.74-7.03 7.69a12.001 12.001 0 0 1-7.13 3.79c-6.32.93-12.27-3.23-13.56-9.49l-8.5-41.28-3.38-4.97a18.92 18.92 0 0 1-3.1-7.99l-.31-2.14c-1.27-8.83 3.74-17.38 12.07-20.58"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    fill: "#e3e1d8",
    d: "M454.13 190.11c12.2-4.68 25.7-4.76 37.95-.22l2.6.96c3.84 1.42 6.51 4.94 6.85 9.03l.07.82c.3 3.6-1.26 7.1-4.14 9.28l-7.29 1.37a50.17 50.17 0 0 1-17.75.16l-4.59-.78a4.196 4.196 0 0 0-4.88 3.67l-1.17 10.39-2.9 2.92-5.4-5.69-.94-.3c-2.08-.67-4.18-.16-5.73 1.06l-1.34-1.97a19.053 19.053 0 0 1-3.1-7.99l-.31-2.14c-1.27-8.82 3.74-17.37 12.07-20.57"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#009df0",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3.346,
    d: "M485.61 252.35h0l-.41 9.65c-.17 3.91-1.96 7.58-4.94 10.12"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#009df0",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3.346,
    d: "M474.74 254.23c6.86 0 15.25-2.61 19.68-15.53 4.39-12.78 3.06-28.72 3.06-28.72 2.87-2.19 4.43-5.69 4.14-9.28l-.07-.83c-.34-4.08-3.01-7.6-6.85-9.03l-2.6-.96a53.798 53.798 0 0 0-37.95.22c-8.34 3.2-13.34 11.75-12.06 20.58l.31 2.14c.41 2.86 1.48 5.59 3.1 7.99l3.38 4.97 4.47 21.71a10.98 10.98 0 0 1-6.6 12.39l-5.99 2.45"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#009df0",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2.231,
    d: "M458.89 227.72h0c1.88-1.89 3.07-4.37 3.37-7.02l.7-6.29c.27-2.4 2.5-4.08 4.88-3.67l7.16 1.22c4.15.71 8.42.45 12.45-.77"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffe3cc",
    d: "M453.49 222.03l-.95-.3c-3.86-1.25-7.86 1.5-8.08 5.55a6.185 6.185 0 0 0 3.89 6.09l5.92 2.37"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#009df0",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3.346,
    d: "M453.49 222.03l-.95-.3c-3.86-1.25-7.86 1.5-8.08 5.55a6.185 6.185 0 0 0 3.89 6.09l5.92 2.37"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#009df0",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2.4,
    d: "M485.7 222.58l3.94.63M471.66 223.95l-4.1 1.33M474.74 242.76l1.63.17c1.95.21 3.93.07 5.84-.38l.04-.01M477.43 236.5l.49.16c.64.21 1.33.15 1.93-.16l.48-.25c.79-.49 1.08-1.49.7-2.33l-.32-.7M470.89 227.72v.64M486.68 226.48v.64"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#009df0",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3.346,
    d: "M417.51 468.13l-20.54-5.05M446.73 259.89l-23.17 9.65a29.173 29.173 0 0 0-17.46 21.86l-9.11 51.8c-1.98 11.22 7.62 21.1 18.89 19.45l9.62-1.41c5.69-.83 10.88-3.71 14.6-8.09 2.07-2.45 4.63-4.44 7.49-5.88 4.77-2.36 7.78-7.23 7.78-12.55v-22.65l-19.51 5.26-1.54-22.98"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#009df0",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2.4,
    d: "M402.74 497.3l-21.32-5.97M498.27 537.57h-21.91"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#009df0",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3.346,
    d: "M539.16 545.6l-21.98-127.23h-69.45"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M15.37 349.44h922.85a6.7 6.7 0 0 1 0 13.4H15.37c-3.7 0-6.7-3-6.7-6.7.01-3.7 3.01-6.7 6.7-6.7"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#009df0",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3.346,
    d: "M15.37 349.44h922.85a6.7 6.7 0 0 1 0 13.4H15.37c-3.7 0-6.7-3-6.7-6.7.01-3.7 3.01-6.7 6.7-6.7z"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    fill: "#b2e2fa",
    d: "M847.77 362.83h14.54l17.21 183.91h-10.08z"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#009df0",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3.346,
    d: "M847.77 362.83h14.54l17.21 183.91h-10.08z"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    fill: "#b2e2fa",
    d: "M73.33 362.83H58.79L41.57 546.74h10.08z"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#009df0",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3.346,
    d: "M73.33 362.83H58.79L41.57 546.74h10.08z"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    fill: "#b2e2fa",
    d: "M132.47 362.83h-14.54l-17.21 183.91h10.08z"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#009df0",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3.346,
    d: "M132.47 362.83h-14.54l-17.21 183.91h10.08z"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#009df0",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2.4,
    d: "M472.24 279.32l4.8 5.05c1.69 1.78 4.6 1.56 6.03-.44 6.3-8.82 7.87-12.75 8.48-19.42M463.75 284.37c-1.69 1.78-4.6 1.56-6.03-.43-6.3-8.82-7.87-12.76-8.48-19.42"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    fill: "#b2e2fa",
    d: "M398.04 280.45h-75.58l-23.73 68.87h75.58z"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#009df0",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3.346,
    d: "M398.04 280.45h-75.58l-23.73 68.87h75.58z"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    fill: "#b2e2fa",
    d: "M350.64 337.76h-97.55c-3.19 0-5.78 2.59-5.78 5.78s2.59 5.78 5.78 5.78h91.29"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#009df0",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3.346,
    d: "M350.64 337.76h-97.55c-3.19 0-5.78 2.59-5.78 5.78s2.59 5.78 5.78 5.78h91.29"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    fill: "#8cd3f8",
    d: "M327.86 287.63l-14.96 43.44h59.82l14.97-43.44z"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    fill: "#b2e2fa",
    d: "M576.02 337.76h97.55c3.19 0 5.78 2.59 5.78 5.78s-2.59 5.78-5.78 5.78h-91.3"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#009df0",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3.346,
    d: "M576.02 337.76h97.55c3.19 0 5.78 2.59 5.78 5.78s-2.59 5.78-5.78 5.78h-91.3"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    fill: "#b2e2fa",
    d: "M528.62 280.45h75.57l23.73 68.87h-75.58z"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#009df0",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3.346,
    d: "M528.62 280.45h75.57l23.73 68.87h-75.58z"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    fill: "#b2e2fa",
    d: "M686.4 280.45h75.58l23.72 68.87h-75.58z"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#009df0",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3.346,
    d: "M686.4 280.45h75.58l23.72 68.87h-75.58z"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    fill: "#b2e2fa",
    d: "M733.8 337.76h97.55c3.19 0 5.78 2.59 5.78 5.78s-2.59 5.78-5.78 5.78h-91.29"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#009df0",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3.346,
    d: "M733.8 337.76h97.55c3.19 0 5.78 2.59 5.78 5.78s-2.59 5.78-5.78 5.78h-91.29"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M756.57 287.63l14.97 43.44h-59.83l-14.96-43.44z"
  })), _defs3 || (_defs3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000000925286096916873870000003743628263951906457_",
    d: "M816.81 272.86h107.03v76.55H816.81z"
  }))), _clipPath3 || (_clipPath3 = /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000018235513180149430320000011907503017786964116_"
  }, /*#__PURE__*/React.createElement("use", {
    overflow: "visible",
    xlinkHref: "#SVGID_00000000925286096916873870000003743628263951906457_"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#SVGID_00000018235513180149430320000011907503017786964116_)"
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000039845183029874361410000016614790746527580592_",
    d: "M816.81 272.86h107.03v76.55H816.81z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000122697388382073986400000013753316295298061752_"
  }, /*#__PURE__*/React.createElement("use", {
    overflow: "visible",
    xlinkHref: "#SVGID_00000039845183029874361410000016614790746527580592_"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#1aa7f1",
    d: "M905.33 272.86l18.51 76.56h-68.79l-2.99-25.34 35.87-6.78z",
    clipPath: "url(#SVGID_00000122697388382073986400000013753316295298061752_)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000129175327300997195430000005115670131620395412_",
    d: "M816.81 272.86h107.03v76.55H816.81z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000160900532467750789390000005029962015475148961_"
  }, /*#__PURE__*/React.createElement("use", {
    overflow: "visible",
    xlinkHref: "#SVGID_00000129175327300997195430000005115670131620395412_"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#e2b290",
    d: "M840.01 329.08c2.5-2.28 5.58-3.79 8.92-4.42l3.12-.58 2.99 25.34h-31.59c-4.86 0-8.07-5-6.02-9.41.8-1.7 2.32-2.99 4.1-3.52l11.38-3.39c2.64-.77 5.05-2.15 7.1-4.02",
    clipPath: "url(#SVGID_00000160900532467750789390000005029962015475148961_)"
  })))), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#009df0",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3.346,
    d: "M852.06 324.08l35.87-6.78 17.4-44.43 18.51 76.55H823.46c-4.86 0-8.07-5-6.02-9.41.8-1.7 2.32-2.99 4.1-3.52l11.38-3.39c2.63-.76 5.04-2.14 7.09-4.02 2.5-2.28 5.58-3.79 8.92-4.42l3.13-.58zM852.06 324.08l2.99 25.34"
  })), _defs4 || (_defs4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000134213407304146694520000010723918093111447993_",
    d: "M820.39 248.82h188.4v297.92h-188.4z"
  }))), _clipPath4 || (_clipPath4 = /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000132051189365646422580000012645471713853224107_"
  }, /*#__PURE__*/React.createElement("use", {
    overflow: "visible",
    xlinkHref: "#SVGID_00000134213407304146694520000010723918093111447993_"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#SVGID_00000132051189365646422580000012645471713853224107_)"
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000067933094602602364090000005600653708312584370_",
    d: "M820.39 248.82h188.4v297.92h-188.4z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000183251220088209349180000018131213039257200814_"
  }, /*#__PURE__*/React.createElement("use", {
    overflow: "visible",
    xlinkHref: "#SVGID_00000067933094602602364090000005600653708312584370_"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#33b1f3",
    d: "M1005.89 320.78c.09.62.22 1.25.27 1.87-.31 3.3-.76 6.38-1.25 9.19-1.92 11.33-12.76 19.18-24.54 17.31-7.81-1.2-14.19-7-16.91-14.45l-13.7-37.3 32.57-10.66 13.56 31.54 10 2.5z",
    clipPath: "url(#SVGID_00000183251220088209349180000018131213039257200814_)"
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000143597364494151091030000011875446893652244896_",
    d: "M820.39 248.82h188.4v297.92h-188.4z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000060002582855024699330000010612365273097194624_"
  }, /*#__PURE__*/React.createElement("use", {
    overflow: "visible",
    xlinkHref: "#SVGID_00000143597364494151091030000011875446893652244896_"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#33b1f3",
    d: "M1000.76 268.31c6.56 20.61 6.91 39.79 5.4 54.34-.04-.62-.18-1.25-.27-1.87l-9.99-2.5-13.56-31.54-32.57 10.66 13.7 37.3c2.72 7.45 9.1 13.25 16.91 14.45 11.78 1.87 22.62-5.98 24.54-17.31.49-2.81.94-5.89 1.25-9.19 1.74 11.11 2.59 22.31 2.63 33.5H906.06l-1.74-73.52c-.4-18.56 14.5-33.82 33.06-33.82h36.54c12.21.01 23.14 7.86 26.84 19.5",
    clipPath: "url(#SVGID_00000060002582855024699330000010612365273097194624_)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000026860145230088964600000000242416145017578420_",
    d: "M820.39 248.82h188.4v297.92h-188.4z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000123427681777478770880000000615621306441478298_"
  }, /*#__PURE__*/React.createElement("use", {
    overflow: "visible",
    xlinkHref: "#SVGID_00000026860145230088964600000000242416145017578420_"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#33b1f3",
    d: "M952.8 494.32l-24.36 51.26h-29.93l6.25-31.18c.85-4.02-.22-8.16-2.81-11.33l-7.09-8.74 15.61-48.09 1.25.4 12.36 15.26c1.92 2.41 3.08 5.4 3.3 8.48.31 4.68 2.81 8.97 6.74 11.6l18.68 12.34z",
    clipPath: "url(#SVGID_00000123427681777478770880000000615621306441478298_)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000040533011019681471730000011019551996986939282_",
    d: "M820.39 248.82h188.4v297.92h-188.4z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000010997148045255757140000004425143389180695955_"
  }, /*#__PURE__*/React.createElement("use", {
    overflow: "visible",
    xlinkHref: "#SVGID_00000040533011019681471730000011019551996986939282_"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#b2e2fa",
    d: "M906.05 356.16h102.74v.85c0 11.55-.85 23.06-2.63 34.53-2.36 15.44-15.66 26.86-31.27 26.86h-55.41l-9.01 27.84-15.61 48.09-4.68 14.45c-.76 2.86-2.01 5.58-3.66 8.03l-4.64 7v22.93H820.4c0-6.74 3.7-12.98 9.59-16.19l4.95-2.72c4.64-2.54 7.99-6.96 9.15-12.09l14.58-63.94 14.05-61.48a21.038 21.038 0 0 1 10.31-13.74l-3.3-6.02 26.32-14.4z",
    clipPath: "url(#SVGID_00000010997148045255757140000004425143389180695955_)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000133488500842464819750000006865360872780138936_",
    d: "M820.39 248.82h188.4v297.92h-188.4z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000091709216522683821470000003881594805540533436_"
  }, /*#__PURE__*/React.createElement("use", {
    overflow: "visible",
    xlinkHref: "#SVGID_00000133488500842464819750000006865360872780138936_"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#b2e2fa",
    d: "M847.43 388.28l32.3-17.71 3.3 6.02c-5.13 2.86-8.97 7.81-10.31 13.74l-14.05 61.47-19.23-24.49c-9.99-12.67-6.15-31.27 7.99-39.03",
    clipPath: "url(#SVGID_00000091709216522683821470000003881594805540533436_)"
  })))), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#009df0",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3.346,
    d: "M1008.79 356.13H906.05l-1.73-73.52c-.43-18.55 14.48-33.82 33.03-33.82"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#009df0",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3.346,
    d: "M952.24 366.97l-61.52 7.18a20.956 20.956 0 0 0-18.01 16.16l-28.63 125.41c-1.17 5.15-4.5 9.55-9.13 12.09l-4.96 2.72a18.456 18.456 0 0 0-9.59 16.2h61.46v-22.92l4.66-7c1.64-2.47 2.88-5.18 3.66-8.04l29.31-90.4h55.41c15.62 0 28.9-11.39 31.27-26.83 3.6-23.46 3.5-47.33-.29-70.76"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#009df0",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3.346,
    d: "M858.68 451.78l-19.24-24.48c-9.97-12.68-6.17-31.28 7.98-39.04l58.64-32.13M911.73 446.61l12.33 15.28c1.95 2.41 3.11 5.37 3.32 8.46.33 4.7 2.82 8.98 6.75 11.59l18.69 12.37-24.35 51.29H898.5l6.28-31.22c.81-4.02-.22-8.17-2.81-11.34l-7.1-8.71M979.65 280.48l16.23 37.81M982.33 286.72l-32.54 10.68 13.69 37.3c2.73 7.44 9.09 13.23 16.91 14.47 11.74 1.86 22.58-5.99 24.52-17.31 2.57-15.04 3.91-38.23-4.15-63.56-3.7-11.64-14.63-19.5-26.84-19.5h-36.56"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    fill: "#e2b290",
    d: "M967.98 253.54l-.82-3.31a29.797 29.797 0 0 1 1.56-18.93l4.36-10.12a40.761 40.761 0 0 0 3.63-21.32c-1.4-13.91-12.66-24.75-26.61-25.62l-2.52-.16c-10.65-.66-20.45 6.81-25.83 15.38a28.536 28.536 0 0 0-2.63 5.38c-.54 1.5-.97 3.07-1.26 4.7l-.03.21c-.5 3.39-.49 6.84.03 10.23l.3 1.98c.34 2.21.3 4.47-.13 6.67l-1.16 5.95a4.374 4.374 0 0 0 3.48 5.13l1.87 7.17c1.28 4.92 5.69 8.39 10.77 8.48l1.72.03 1.47 8.95c.8 4.92 4.31 8.95 9.07 10.44 4.31 1.35 9.02.4 12.46-2.53l10.27-8.71z"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    fill: "#40b6f4",
    d: "M966.78 218.32c.04-2.2-1.2-4.33-3.25-5.11a5.133 5.133 0 0 0-5.99 1.78l-.75 1.05c-2.2 3.06-6.85 2.76-8.63-.56l-5.57-10.36a5.13 5.13 0 0 0-4.4-2.69l-3.41.53c-4.9.76-9.91.23-14.55-1.53l-2.01-.76c.04-.31.06-.62.1-.92l.03-.21c.29-1.62.71-3.19 1.26-4.7.69-1.9 1.57-3.7 2.62-5.38 5.75-9.16 16.54-16.76 28.03-15.15 13.09 1.82 25.21 8.61 26.54 21.76l.38 3.8c.73 7.3-.52 14.67-3.64 21.32l-6.66 14.76-2.06-3.21a7.597 7.597 0 0 1 .26-8.59 8.567 8.567 0 0 0 1.66-4.93l.04-.9z"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#009df0",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2.4,
    d: "M919.7 228.42l5.03.89M930.53 218.37v.12M926.65 213.46h0a24.82 24.82 0 0 0 8.29 2.34l.66.07M923.01 234.44l.28.06c.97.22 2.55.32 4.13-.63"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#009df0",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3.346,
    d: "M936.27 255.25l-1.54-9.87-1.72-.03c-5.08-.09-9.48-3.56-10.77-8.48l-1.87-7.17a4.374 4.374 0 0 1-3.48-5.13l1.16-5.95c.43-2.2.48-4.46.13-6.67l-.3-1.98c-.52-3.39-.53-6.83-.03-10.23l.03-.21c.29-1.62.71-3.19 1.26-4.7.69-1.9 1.57-3.7 2.62-5.38 5.38-8.57 15.18-16.04 25.83-15.38l2.51.16c13.95.87 25.21 11.72 26.61 25.62.73 7.3-.52 14.67-3.64 21.32l-4.36 10.12a29.865 29.865 0 0 0-1.56 18.93l.82 3.31M934.73 245.38l9.07.17"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    fill: "#e2b290",
    d: "M960.38 293.68l-23.71-23.15a11.156 11.156 0 0 1-3.29-9.4l.47-3.76-.7-4.89a6.217 6.217 0 0 1 3.59-6.53c1.98-.89 4.27-.69 6.06.54l21.97 15.01a5.44 5.44 0 0 0 5.32.45c3.43-1.57 7.37.75 7.67 4.51l1.13 14.03 2.68 6.25-21.19 6.94z"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#009df0",
    strokeMiterlimit: 10,
    strokeWidth: 3.346,
    d: "M960.38 293.68l-23.71-23.15a11.156 11.156 0 0 1-3.29-9.4l.47-3.76-.7-4.89a6.217 6.217 0 0 1 3.59-6.53c1.98-.89 4.27-.69 6.06.54l21.97 15.01a5.44 5.44 0 0 0 5.32.45c3.43-1.57 7.37.75 7.67 4.51l1.13 14.03 2.68 6.25-21.19 6.94z"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#009df0",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3.346,
    d: "M1002.27 545.6l-21.98-127.23h-69.45"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M61.77 300.62H28.29l1.53 16.1h30.42z"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    fill: "#8cd3f8",
    d: "M29.82 316.72l2.93 30.78h24.56l2.93-30.78z"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M258.27 314.88l-10.96 4.32 29.23 28.36 69.57-28.65-29.77-26.8-31.75 12.43 2.9 1.69c2.78 1.48 2.92 5.41.25 7.05-.69.43-1.45.66-2.25.65-.52-.01-1.04-.13-1.56-.34l-10.55-4.6-15.11 5.89z"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffe3cc",
    d: "M266.48 301.31a11.862 11.862 0 0 1-9.97-.35l-51.65-26.25-7.21 22.22 60.61 17.95 15.11-5.91 10.55 4.6c.52.21 1.04.33 1.56.34.8.01 1.57-.22 2.25-.65 2.67-1.65 2.53-5.57-.25-7.06l-2.9-1.68-6.59-3.78a9.882 9.882 0 0 0-8.81-.57l-2.7 1.14z"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#009df0",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3.346,
    d: "M258.27 314.88l-60.61-17.95 7.21-22.22 51.65 26.24a11.9 11.9 0 0 0 9.97.35l2.7-1.12c2.86-1.2 6.11-.99 8.81.57l6.59 3.78 2.9 1.69c2.78 1.48 2.92 5.41.25 7.05-.69.43-1.45.66-2.25.65-.52-.01-1.04-.13-1.56-.34l-10.55-4.6-15.11 5.9-10.96 4.32 29.23 28.36 69.57-28.65-29.77-26.8-31.75 12.43"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M221.38 279.99l-5.28 24.53-19.76-7.31a52.641 52.641 0 0 1-19.5-12.72l-24.92-25.76 27.78-18.5 21.79 27.94 19.89 11.82z"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#009df0",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3.346,
    d: "M221.38 279.99l-5.28 24.53-19.76-7.31a52.641 52.641 0 0 1-19.5-12.72l-24.92-25.76 27.78-18.5 21.79 27.94 19.89 11.82z"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffe3cc",
    d: "M121.98 285.58L89.66 339.4a6.774 6.774 0 0 0-.41 6.19c1.02 2.36.62 5.1-1.04 7.07l-8.03 9.53a4.144 4.144 0 0 1-6.3.05 4.138 4.138 0 0 0-4.94-1.01l-18.05 8.78c-1.01.49-2.12.75-3.24.75-5.64 0-9.21-6.05-6.5-10.99l2.53-4.6a16.61 16.61 0 0 1 9.35-7.76l10.8-3.56c2.83-.94 5.2-2.93 6.6-5.56l33.71-63.23"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#009df0",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3.346,
    d: "M121.98 285.58L89.66 339.4a6.774 6.774 0 0 0-.41 6.19c1.02 2.36.62 5.1-1.04 7.07l-8.03 9.53a4.144 4.144 0 0 1-6.3.05 4.138 4.138 0 0 0-4.94-1.01l-18.05 8.78c-1.01.49-2.12.75-3.24.75-5.64 0-9.21-6.05-6.5-10.99l2.53-4.6a16.61 16.61 0 0 1 9.35-7.76l10.8-3.56c2.83-.94 5.2-2.93 6.6-5.56l33.71-63.23"
  })), _defs5 || (_defs5 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000038374860808229597790000004579676314422723511_",
    d: "M111.94 193.72h190.25v353.02H111.94z"
  }))), _clipPath5 || (_clipPath5 = /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000031202694602102438360000005670610430142584710_"
  }, /*#__PURE__*/React.createElement("use", {
    overflow: "visible",
    xlinkHref: "#SVGID_00000038374860808229597790000004579676314422723511_"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#SVGID_00000031202694602102438360000005670610430142584710_)"
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000005958104125743635930000014775958070130493836_",
    d: "M111.94 193.72h190.25v353.02H111.94z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000050624746318312175580000003653364433480250290_"
  }, /*#__PURE__*/React.createElement("use", {
    overflow: "visible",
    xlinkHref: "#SVGID_00000005958104125743635930000014775958070130493836_"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#add095",
    d: "M217.92 442.39l2.23 76.87c.09 3.03 1.56 5.84 3.97 7.67 1.87 1.43 3.17 3.48 3.7 5.75l3.17 14.05h-49.56l-8.92-125.98-41.44-71.33h-12.76l-2.41-10.17a147.513 147.513 0 0 1-2.63-53.62l.27.04h82.67c-.31 2.9-.4 5.84-.22 8.74l1.07 16.28 54.2 82.35c5.17 7.9 8.57 16.86 9.9 26.19l12.58 88.42c.76 5.53 4.06 10.39 8.92 13.21l10.75 6.16c2.41 1.38 4.15 3.61 4.91 6.25l3.88 13.47h-52.73l-6.78-21.24-24.77-83.11z",
    clipPath: "url(#SVGID_00000050624746318312175580000003653364433480250290_)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000043436003051378444420000000810038988324968070_",
    d: "M111.94 193.72h190.25v353.02H111.94z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000017517878860460947660000010465474272302507673_"
  }, /*#__PURE__*/React.createElement("use", {
    overflow: "visible",
    xlinkHref: "#SVGID_00000043436003051378444420000000810038988324968070_"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#add095",
    d: "M181.92 196.76c15.66 2.05 26.37 16.86 23.42 32.39L199 262.61c-.22 1.16-.4 2.32-.54 3.48l-2.28 19.58h-82.67l-.27-.04c.09-.67.18-1.29.27-1.96l9.37-62.95c1.74-12 9.86-22.13 21.19-26.46l14.54-.54 23.31 3.04z",
    clipPath: "url(#SVGID_00000017517878860460947660000010465474272302507673_)"
  })))), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#009df0",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3.346,
    d: "M217.92 442.32l24.77 83.18 6.77 21.23h52.75l-3.89-13.48c-.76-2.64-2.51-4.87-4.89-6.23l-10.77-6.17a18.103 18.103 0 0 1-8.93-13.17l-12.58-88.43a64.18 64.18 0 0 0-9.9-26.19l-54.21-82.39-1.05-16.25c-.19-2.92-.12-5.85.22-8.76l2.26-19.57c.13-1.17 8.4-1.9 8.62-3.06v-34.24c0-11.49-5.81-22.21-15.45-28.47l-23.51-15.28-24.02 9.2a33.593 33.593 0 0 0-21.21 26.45l-9.33 62.94a147.465 147.465 0 0 0 2.36 55.61l2.4 10.18h12.77l41.41 71.33 8.93 125.97h49.6l-3.19-14.03a9.94 9.94 0 0 0-3.71-5.75 10.004 10.004 0 0 1-3.95-7.67l-2.98-101.93-22.15-80.59M178.82 285.67h-52.9"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M154.87 190.13l3.41 10.58c5.06 15.72 7.64 32.14 7.64 48.66v78.55h-57.55V283c0-.01 12.78-96.46 46.5-92.87"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#009df0",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3.346,
    d: "M154.87 190.13l3.41 10.58c5.06 15.72 7.64 32.14 7.64 48.66v78.55h-57.55V283c0-.01 12.78-96.46 46.5-92.87z"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M125.91 210.67L80.49 311.16l22.91 9.1 38.65-65.28"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#009df0",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3.346,
    d: "M125.91 210.67L80.49 311.16l22.91 9.1 38.65-65.28"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffe3cc",
    d: "M158.65 193.72l.57-3.1a27.59 27.59 0 0 0-2.49-17.39l-4.59-9.1a37.638 37.638 0 0 1-4.54-19.47c.51-12.91 10.31-23.55 23.13-25.13l2.31-.29c9.79-1.2 19.26 5.14 24.7 12.75 1.06 1.49 1.98 3.1 2.72 4.82.59 1.36 1.07 2.78 1.42 4.27l.04.19c.65 3.1.83 6.29.54 9.44l-.17 1.84c-.19 2.07-.02 4.14.5 6.15l1.41 5.42c.56 2.17-.75 4.38-2.92 4.93l-1.81 9.13a7.247 7.247 0 0 1-6.54 5.82l-4.04.32-.85 8.34a12.17 12.17 0 0 1-7.78 10.14c-3.91 1.49-8.3.87-11.64-1.64l-9.97-7.44z"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#009df0",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2.231,
    d: "M201.8 167.84l-4.59 1.1"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#009df0",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3.346,
    d: "M188.88 184.33l-8.18-1.69"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    fill: "#40b6f4",
    d: "M192.38 139.97c2.43 4.38 7.18 5.71 10.13 6.1-.06-1.59-.26-3.2-.61-4.78l-.04-.21c-.34-1.49-.83-2.92-1.4-4.28-.76-1.71-1.68-3.34-2.73-4.82-5.45-7.62-14.9-13.94-24.72-12.75l-2.31.29c-17.33 3.36-35.23 21.67-28.75 42.35 6.45 20.73-25.03 16.47-20.31 48.48 1.02 7.06 10.6 6.8 17.8 4.32 39.75-13.83 17.27-41.46 24.7-50.84 7.47-9.37 24.37-6.15 28.24-23.86"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#009df0",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3.346,
    d: "M192.4 139.97c-3.87 17.71-20.78 14.48-28.23 23.87s15.07 37.08-24.72 50.82"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#009df0",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3.346,
    d: "M187.56 198.18l1.32-13.85c5.2.54 9.95-2.98 10.97-8.11l1.42-7.16c2.17-.54 3.48-2.76 2.92-4.93l-1.41-5.42c-.52-2.01-.68-4.09-.5-6.15l.17-1.84c.29-3.16.11-6.34-.54-9.44l-.04-.19c-.36-1.48-.83-2.91-1.42-4.27-.74-1.72-1.66-3.33-2.72-4.82-5.44-7.61-14.9-13.96-24.7-12.75l-2.31.28c-17.35 3.38-35.23 21.65-28.78 42.36 6.46 20.71-27.74 16.98-20.3 48.49"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#009df0",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2.4,
    d: "M194.3 159.32l.16.38M193.58 155.36l-1.18.71c-1.16.7-2.03 1.78-2.46 3.06"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#009df0",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2.231,
    d: "M195.42 174.58c-1.87.58-4.06-1.49-4.06-1.49"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M191.63 200.33c9.64 6.26 15.37 14.66 15.37 26.16l.22 2.32v99.11H195.3V218.95c0-7.63-2.74-15-7.73-20.78"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#009df0",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3.346,
    d: "M191.63 200.33c9.64 6.26 15.37 14.66 15.37 26.16l.22 2.32v99.11H195.3V218.95c0-7.63-2.74-15-7.73-20.78M11.23 546.74h451.29"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    fill: "#add095",
    d: "M99 112.64c-4.12-9.15-6.17-20.85-6.17-30.35H63.18c0 9.5 2.06 21.2 6.18 30.35H99z"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    fill: "#8cd3f8",
    d: "M689.42 155.15c4.12-9.15 6.18-20.85 6.18-30.35h29.64c0 9.5-2.06 21.2-6.18 30.35h-29.64z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBusinessintegrity);
export default __webpack_public_path__ + "static/media/Business integrity.33df5d9b496a747e314ddb711bbc6797.svg";
export { ForwardRef as ReactComponent };